Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentYoutubeMediaView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_youtube_media"]
  className: 'sc-media'

  initialize: (options = {}) ->
    @video = options.video
    @thumbnail = options.thumbnail

  render: ->
    @$el.html @template {@video, @thumbnail }
    @_playButtonHover()
    @_checkThumbnail()
    this

  _playButtonHover: ->
    @$el.find('.hover').hide()
    @$el.closest(".sc-media").find(".hover").hide()
    @$el.closest(".sc-media").hover ( ->
      $(this).find('.hover').show()
      return
    ), ->
      $(this).find('.hover').hide()
      return

  _checkThumbnail: ->
    @$el.find('.defaultThumbnail').hide()
    if @thumbnail == ''
      @$el.find('.defaultThumbnail').show()
      @$el.find(".sc-video-preview").hide()
    return
